export interface UserTranslations {
  TABLE: {
      NAME: string;
      LAST_NAME: string;
      NATIONALITY: string;
      ACTIONS: string;
      BUTTON: string;
      USUARIOS: string;
      VALIDADO: string;
      ACTIVO: string;
  };
  // Aquí puedes añadir más secciones de traducción según lo necesites

  // Esta línea es la clave para que el objeto sea indexable por TypeScript
  [key: string]: any;  // Usamos 'any' para simplificar, pero podrías ser más específico si quieres
}

export const userTranslations: { [language: string]: UserTranslations } = {
    en: {
        TABLE: {
            NAME: "Name",
            LAST_NAME: "Surname",
            NATIONALITY: "Nationality",
            ACTIONS: "Actions",
            BUTTON: "New administrator",
            USUARIOS: "Administrators",
            VALIDADO: "Validated",
            ACTIVO: "Active"
        },
    },
    es: {
        TABLE: {
            NAME: "Nombre",
            LAST_NAME: "Apellidos",
            NATIONALITY: "Nacionalidad",
            ACTIONS: "Acciones",
            BUTTON: "Nuevo administrador",
            USUARIOS: "Administradores",
            VALIDADO: "Validado",
            ACTIVO: "Activo"
        },
    }
};

